import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionText from '@liveauctioneers/caterwaul-components/lib/ActionText/ActionText';
import { faBullhorn } from '@fortawesome/pro-duotone-svg-icons/faBullhorn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { getCatalogAnnouncement } from '@/redux/modules/catalogAnnouncement';
import { openCatalogAnnouncementModal } from '@/redux/modules/modal';
import { safelyRender } from '@/utils/safelyRender';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    catalogId: number;
};

const Announcement = ({ catalogId }: Props) => {
    const dispatch = useDispatch();
    const { title } = useSelector((state) => getCatalogAnnouncement(state, catalogId));

    const openCatalogAnnouncement = React.useCallback(() => dispatch(openCatalogAnnouncementModal(catalogId)), [
        catalogId,
        dispatch,
    ]);

    return Boolean(title) ? (
        <AnnouncementContainer>
            <StyledIcon icon={faBullhorn} />
            <div>
                <Text h6>{safelyRender(title, 'span')}</Text>
                <StyledActionText onClick={openCatalogAnnouncement}>
                    <FormattedMessage id="shippingInfo.announcement.read" />
                </StyledActionText>
            </div>
        </AnnouncementContainer>
    ) : null;
};

export default React.memo<Props>(Announcement);

const AnnouncementContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 20px 0;
`;

const StyledActionText = styled(ActionText)`
    font-family: ${({ theme }) => theme.typography.fontPrimary};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    text-decoration: underline !important;
`;

const StyledIcon = styled(FontAwesomeIcon)`
    width: 30px !important;
    height: 24px !important;
    margin-right: 15px;
`;
